import type { Release } from '../releases';

export default {
  id: '2026-10-31-support-release-close',
  at: '2026-11-01T05:22:00Z',
  title: 'Ошибка из поддержки закрывается в день выкладки исправления',
  modules: ['support'],
  items: [
    'В обращении «Ошибка», переданном разработке, специалист указывает выпуск — запись «Что нового», с которой выйдет исправление. В день выкладки обращение закрывается само, автор получает сообщение в портале и на почту или в Telegram.',
    'Если исправление не помогло, автор оценивает ответ «не решён» — обращение возвращается в работу.',
    'В отчёте поддержки — блок приёмки: доля первых ответов в срок (цель — от 95 %), открытые ошибки старше пяти рабочих дней со ссылками и ошибки, ждущие выкладки.',
  ],
  why: 'Выпуск исправления отмечали вручную, и обращения оставались открытыми после выкладки, а цифры приёмки по срокам ответа и старым ошибкам считали руками.',
  link: '/support?tab=report',
} satisfies Release;
